// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Filter = createIcon(
  <path
    clipRule="evenodd"
    d="M4.1001 7.99961C4.1001 7.50255 4.50304 7.09961 5.0001 7.09961H19.0001C19.4972 7.09961 19.9001 7.50255 19.9001 7.99961C19.9001 8.49667 19.4972 8.89961 19.0001 8.89961H5.0001C4.50304 8.89961 4.1001 8.49667 4.1001 7.99961ZM6.6001 11.9996C6.6001 11.5026 7.00304 11.0996 7.5001 11.0996H16.5001C16.9972 11.0996 17.4001 11.5026 17.4001 11.9996C17.4001 12.4967 16.9972 12.8996 16.5001 12.8996H7.5001C7.00304 12.8996 6.6001 12.4967 6.6001 11.9996ZM10.0001 15.0996C9.50304 15.0996 9.1001 15.5026 9.1001 15.9996C9.1001 16.4967 9.50304 16.8996 10.0001 16.8996H14.0001C14.4972 16.8996 14.9001 16.4967 14.9001 15.9996C14.9001 15.5026 14.4972 15.0996 14.0001 15.0996H10.0001Z"
    fillRule="evenodd"
  />,
);
